<script setup lang="ts">
import { onBeforeRouteUpdate } from "vue-router";

const { off } = useRoute().query;

const current = ref(off ? parseInt(off as string) : 0);

const {
  data: news,
  refresh,
  pending,
} = await useFetch(() => `/api/top/news?type=list&off=${current.value}`);

onBeforeRouteUpdate((to, from, next) => {
  if (to.query.off) {
    current.value = parseInt(to.query.off as string);
    refresh();
  }
  next();
});

useHead({
  title: "最新情報",
});
useScrollTop(true);
useBreadcrumbs([
  { name: "TOP", path: "/" },
  { name: "最新情報", path: "/news" },
]);
</script>

<template>
  <div class="p-news wrapper mb-16">
    <TextPageTitle>最新情報</TextPageTitle>
    <div class="p-news__list">
      <Transition name="fade">
        <ul v-if="!pending" class="p-news__list mb-8">
          <NewsLi v-for="n in news" :news="n" :key="n.link" />
        </ul>
      </Transition>
      <Pagination :max="100" :current="current" />
    </div>
  </div>
</template>
<style scoped lang="scss">
.p-news {
  @apply pc:justify-around pc:flex;

  &__list {
    @apply mx-auto pc:w-fit;
  }
}
</style>
